import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {WalletCard, WalletCardStyle} from "../../../ui/WalletCard";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {PaymentMethodStore, WalletStore} from "../../../../State";
import {RollAnimatedBalance} from "../../../../common/RollAnimatedBalance";
import {AddFundsButton} from "../../../../website/pages/wallet/components/AddFundsButton";
import {AutoReloadToggle} from "../../../../common/AutoReloadToggle.jsx";
import {Money} from "../../../../../stem-core/src/localization/Money.js";
import {TOP_UP_VALUES} from "../../../../Constants";
import {RadioButtonsInput} from "../../../../../core/ui/input/radio/RadioButtonsInput.jsx";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw.js";
import {WidgetRoutes} from "../../../WidgetRoutes.js";
import {Router} from "../../../../../stem-core/src/ui/Router.jsx";
import {PaymentMethodDescription} from "../../../../common/PaymentMethodDescription.jsx";
import {Messages} from "../../../../Messages.js";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";


// TODO @cleanup probably remove this
export const MakeLargeWalletBalanceStyle = props => ({
    fontSize: 48,
    height: "1em",
    fontWeight: 200,
    display: "block",
    transform: "none !important",
    margin: "24px 0 36px",
    color: props.WALLET_BALANCE_COLOR,
});

class AddFundsExpandedStyle extends WalletCardStyle {
    @styleRuleInherit
    container = {
        minHeight: "",
    };

    @styleRuleInherit
    content = {
        overflow: "hidden",
    };

    @styleRule
    primaryCardContainer = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
    };

    @styleRule
    changePrimaryCardLabel = {
        display: "flex",
        alignItems: "center",
    };

    @styleRule
    line = {
        marginTop: 18,
    };

    @styleRule
    balance = {
        ...MakeLargeWalletBalanceStyle(this.themeProps),
        opacity: 0,
    };

    @styleRule
    horizontalPadding = {
        padding: "0 24px",
    };

    @styleRule
    radioButtonsInput = {
        display: "flex",
        width: "100%",
        margin: 0,
    }
}

// TODO @cleanup this is a user view on a wallet
@registerStyle(AddFundsExpandedStyle)
@autoredraw(PaymentMethodStore, WalletStore)
export class AddFundsExpanded extends WalletCard {
    activeValue;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            testId: "addFundsExpanded",
            userWallet: WalletStore.getWallet(),
        }
    }

    getCurrency() {
        return this.options.userWallet.getCurrency();
    }

    renderAdvancedSection() {
        const {styleSheet} = this;
        const paymentMethod = PaymentMethodStore.getPrimary();
        if (!paymentMethod) {
            return null;
        }

        const onCardChangeClick = (event) => {
            event.stopPropagation();
            Router.changeURL(WidgetRoutes.CHOOSE_CARD);
        }

        return [
            <div className={styleSheet.line + styleSheet.primaryCardContainer}>
                <PaymentMethodDescription testId="walletPrimaryCardDetails" paymentMethod={paymentMethod}/>
                <LinkButton
                    testId="walletChangeCardButton"
                    label={Messages.change}
                    className={styleSheet.changePrimaryCardLabel}
                    onClick={onCardChangeClick}
                />
            </div>,
            <AutoReloadToggle className={styleSheet.line} style={{marginBottom: 4}}/>
        ];
    }

    render() {
        const {styleSheet} = this;

        const reloadOptions = TOP_UP_VALUES.map(value => this.mainUnitsToOption(value));
        this.activeValue = this.activeValue || reloadOptions[1];

        const onRadioSelect = value => {
            this.activeValue = value;
            this.redraw();
        };

        return [
            <RollAnimatedBalance ref="balance" className={styleSheet.balance}/>,
            <div className={styleSheet.horizontalPadding}>
                <RadioButtonsInput
                    ref="radioButtons"
                    testId="addFundsAmountButtons"
                    initialValue={this.activeValue}
                    values={reloadOptions}
                    onChange={onRadioSelect}
                    className={styleSheet.radioButtonsInput}
                />
                {this.renderAdvancedSection()}
            </div>,
        ];
    }

    mainUnitsToOption(amount) {
        // TODO damn this is ugly af
        return (new Money(this.getCurrency().mainUnitsToAmount(amount), this.getCurrency())).toMainUnitString({decimalsDisplayed: 0});
    }

    getAmountByOption(option) {
        const numUnits = TOP_UP_VALUES.find(value => this.mainUnitsToOption(value) === option);
        return this.getCurrency().mainUnitsToAmount(numUnits);
    }

    renderPrimaryButton() {
        return <AddFundsButton
            testId="addFundsButton"
            amount={this.getAmountByOption(this.activeValue)}
            onNoPaymentMethod={() => Router.changeURL(WidgetRoutes.ADD_CARD)}
        />;
    }
}
